interface Props {
  className?: string;
}

export function Skeleton({ className }: Props) {
  return (
    <span
      aria-hidden="true"
      className={'inline-block animate-pulse rounded-md bg-slate-200 ' + (className ?? 'h-4 w-24')}
    />
  );
}

export function SkeletonRow({ cols }: { cols: number }) {
  return (
    <tr className="animate-pulse">
      {Array.from({ length: cols }, (_, i) => (
        <td key={i} className="px-4 py-3">
          <Skeleton className={'h-3 ' + (i === 0 ? 'w-32' : 'w-20') + ' block'} />
        </td>
      ))}
    </tr>
  );
}
